import { create } from "zustand";

const initialState = {
  q: "",
  l: "",
  date_posted: "all",
  employment_types: ["all"],
  work_from_home: false,
  jobs: [],
  jobsLoading: false,
  hasMoreJobs: true,
  page: 1,
  error: null,
};

const getCSRFToken = () => {
  const meta = document.querySelector('meta[name="csrf-token"]');
  return meta ? meta.getAttribute("content") : "";
};

const useSearchStore = create((set, get) => ({
  ...initialState,

  setField: (field, value) => {
    set((state) => ({
      ...state,
      [field]: value,
      ...(field !== "jobs" && field !== "jobsLoading" && field !== "hasMoreJobs"
        ? { page: 1 }
        : {}),
    }));
  },

  fetchJobs: async (overides = {}) => {
    set((state) => ({
      ...state,
      jobsLoading: true,
      error: null,
      jobs: [],
      hasMoreJobs: true,
      page: 1,
    }));
    try {
      const payload = {
        q: get().q,
        l: get().l,
        date_posted: get().date_posted,
        employment_types: get().employment_types,
        work_from_home: get().work_from_home,
        page: 1,
        ...overides,
      };
      if (payload.employment_types.includes("all")) {
        payload.employment_types = [];
      }
      const res = await fetch(`/jobs/search`, {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          "X-CSRF-Token": getCSRFToken(),
        },
        body: JSON.stringify(payload),
      });
      if (!res.ok) throw new Error("Failed to fetch jobs");
      const data = await res.json();
      set((state) => ({
        ...state,
        jobs: Array.isArray(data) ? data : [],
        jobsLoading: false,
        hasMoreJobs: Array.isArray(data) && data.length > 0,
        page: 2,
      }));
    } catch (e) {
      set((state) => ({
        ...state,
        jobsLoading: false,
        error: e.message || "Error loading jobs",
      }));
    }
  },

  loadMoreJobs: async () => {
    const state = get();
    if (state.jobsLoading || !state.hasMoreJobs) return;
    set((prev) => ({ ...prev, jobsLoading: true }));
    try {
      const payload = {
        q: state.q,
        l: state.l,
        date_posted: state.date_posted,
        employment_types: state.employment_types,
        page: state.page,
        work_from_home: state.work_from_home,
      };
      const res = await fetch(`/jobs/search`, {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          "X-CSRF-Token": getCSRFToken(),
        },
        body: JSON.stringify(payload),
      });
      if (!res.ok) throw new Error("Failed to fetch jobs");
      const data = await res.json();
      set((prev) => ({
        ...prev,
        jobs: [...prev.jobs, ...(Array.isArray(data) ? data : [])],
        jobsLoading: false,
        hasMoreJobs: Array.isArray(data) && data.length > 0,
        page: prev.page + 1,
      }));
    } catch (e) {
      set((prev) => ({
        ...prev,
        jobsLoading: false,
        error: e.message || "Error loading jobs",
      }));
    }
  },
}));

export default useSearchStore;
